<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.ptype"
        class="filter-item"
        style="width: 150px"
        placeholder="请选择"
        clearable
        @change="onptypeChange"
      >
        <el-option label="正式班" value="1"></el-option>
        <el-option label="圈人班" value="2"></el-option>
      </el-select>
      <el-select
        v-model="listQuery.sys_basic_parent"
        class="filter-item"
        style="width: 150px"
        placeholder="请选择"
        clearable
      >
        <el-option
          v-for="(item, index) in otherType"
          :key="index"
          :label="item.name"
          :value="item.uuid"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="listQuery.sys_basic"
        class="filter-item"
        style="width: 150px"
        placeholder="请选择"
        clearable
      >
        <el-option
          v-for="(item, index) in otherType2"
          :key="index"
          :label="item.name"
          :value="item.uuid"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="listQuery.sys_senior"
        class="filter-item"
        style="width: 150px"
        placeholder="请选择"
        clearable
      >
        <el-option
          v-for="(item, index) in otherType3"
          :key="index"
          :label="item.name"
          :value="item.uuid"
        >
        </el-option>
      </el-select>

      <el-input
        style="width: 150px"
        class="filter-item"
        placeholder="课程ID"
        v-model="listQuery.product_num"
      ></el-input>
      <el-input
        style="width: 150px"
        class="filter-item"
        placeholder="课程名称"
        v-model="listQuery.product_name"
      ></el-input>

      <el-select
        clearable
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.allow_status"
        placeholder="开放状态"
      >
        <el-option
          v-for="(item, index) in allowStatusOptions"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="onSearch"
        >搜索</el-button
      >
      <el-button class="filter-item" type="primary" @click="onReset"
        >重置</el-button
      >
    </div>
    <el-table
      :data="list"
      v-loading.body="listLoading"
      element-loading-text="加载中 ..."
      border
      highlight-current-row
    >
      <el-table-column
        type="index"
        align="center"
        label="序号"
        width="50"
      ></el-table-column>
      <el-table-column
        label="课程ID"
        min-width="120"
        align="center"
        prop="num"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="课程名称"
        min-width="300"
        align="center"
        prop="name"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="待审核数"
        width="120"
        align="center"
        prop="wait_audit_count"
      ></el-table-column>
      <el-table-column
        label="未回复数"
        width="120"
        align="center"
        prop="wait_reply_count"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="已回复数"
        width="120"
        align="center"
        prop="reply_count"
      ></el-table-column>
      <el-table-column
        label="未通过数"
        width="120"
        align="center"
        prop="audit_fail_count"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="150px"
        align="center"
        fixed="right"
      >
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" @click="onDetail(row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
  </div>
</template>

<script>
/**
 * @name LearnInteraction
 * @description 学员讨论区管理
 * @author
 * @date 2022-04-20
 */
import { getProduct } from '@/api/common'
import { getList } from '@/api/learn-interaction'
export default {
  name: 'LearnInteraction',
  data() {
    return {
      list: [{}],
      count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        size: 10,
        ptype: '',
        sys_basic_parent: '',
        sys_basic: '',
        sys_senior: '',
        product_num: '',
        product_name: '',
        allow_status: '',
      },
      otherType: [],
      allowStatusOptions: [
        {
          label: '已开放',
          value: true,
        },
        {
          label: '未开放',
          value: false,
        },
      ],
    }
  },
  computed: {
    otherType2({ otherType, listQuery: { sys_basic_parent } }) {
      this.listQuery.sys_basic = ''
      this.listQuery.sys_senior = ''
      return this.findChildrenByType(sys_basic_parent, otherType)
    },
    otherType3({ otherType2, listQuery: { sys_basic } }) {
      this.listQuery.sys_senior = ''
      return this.findChildrenByType(sys_basic, otherType2)
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    onptypeChange() {
      const {
        listQuery: { ptype },
      } = this
      this.listQuery.sys_basic_parent = ''
      this.listQuery.sys_basic = ''
      this.listQuery.sys_senior = ''
      if (!ptype) {
        return
      }
      getProduct({ tp: ptype }).then((res) => {
        this.otherType = res.data
      })
    },
    findChildrenByType(type = '', list = []) {
      if (!type || !list || list.length == 0) {
        return []
      }
      const temp = list.find((item) => item.uuid == type)
      if (!temp) {
        return []
      }
      return temp.children || []
    },
    onSearch() {
      this.listQuery.page = 1
      this.fetchData()
    },
    onReset() {
      Object.assign(this.$data.listQuery, this.$options.data().listQuery)
      this.fetchData()
    },
    fetchData() {
      const { listQuery } = this
      this.listLoading = true
      getList(listQuery).then((res) => {
        this.list = res.data.results || []
        this.count = res.data.count
        this.listLoading = false
      })
    },
    onDetail(row) {
      this.$router.push(`/learn-interaction/detail/${row.uuid}`)
    },
  },
}
</script>

<style lang="less" scoped></style>
